import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { teacherTypography } from '../../design/typography';
import { CETELE_ICONS } from '../../shared/ceteleTemplates';

// Decorative template accents; these colors do not describe evaluation status.
const ACCENTS = {
  english_words: { color: '#db2777', background: '#fff1f7' },
  multiplication: { color: '#4f46e5', background: '#eef2ff' },
  rhythmic_counting: { color: '#0891b2', background: '#ecfeff' },
  poetry: { color: '#ea580c', background: '#fff7ed' },
  letters_syllables: { color: '#2563eb', background: '#eff6ff' },
  custom: { color: '#7c3aed', background: '#f5f3ff' },
};

export default function CeteleListCard({ item, onOpen, onDelete }) {
  const accent = ACCENTS[item.template_key] || ACCENTS.custom;
  return <Box sx={{ position: 'relative', minWidth: 0 }}><Paper component="button" type="button" className="cetele-list-card"
    data-template={item.template_key} onClick={() => onOpen(item.id)}
    sx={{ width: '100%', height: '100%', minWidth: 0, minHeight: 88, p: 1.75, pr: 8,
      display: 'flex', alignItems: 'center', gap: 1.25,
      cursor: 'pointer', textAlign: 'left', color: '#17213c', bgcolor: '#fff',
      border: '1px solid #e8eaf3', borderLeft: '4px solid ' + accent.color,
      borderRadius: '12px', boxShadow: '0 3px 12px rgba(49,47,89,.025)',
      '&:hover': { borderColor: accent.color, boxShadow: '0 4px 14px rgba(49,47,89,.08)' },
      '&:active': { bgcolor: accent.background },
      '&:focus-visible': { outline: '3px solid #352179', outlineOffset: 3 } }}>
    <Box className="cetele-list-card__icon" aria-hidden="true" sx={{
      width: 44, height: 44, flexShrink: 0, borderRadius: '12px',
      bgcolor: accent.background, display: 'grid', placeItems: 'center', fontSize: 25,
    }}>{CETELE_ICONS[item.template_key] || '📋'}</Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography id={'cetele-card-title-' + item.id} component="span" className="cetele-list-card__title" title={item.title} sx={{
        ...teacherTypography.cardTitle, fontSize: { xs: 16, sm: 17 }, lineHeight: 1.4,
        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
        overflow: 'hidden', overflowWrap: 'anywhere',
      }}>{item.title}</Typography>
      <Typography component="span" className="cetele-list-card__metadata" sx={{
        ...teacherTypography.metadata, display: 'block', mt: 0.5, fontSize: 12, lineHeight: 1.5,
        overflowWrap: 'anywhere',
      }}>
        {item.class_code} · {item.subject} · <Box component="span" sx={{ whiteSpace: 'nowrap', fontWeight: 600 }}>
          {item.control_count ?? 0} değerlendirme
        </Box>
      </Typography>
    </Box>
  </Paper>
    <IconButton aria-label="Çeteleyi sil" aria-describedby={'cetele-card-title-' + item.id}
      onClick={() => onDelete(item)} sx={{ position: 'absolute', right: 10, top: 'calc(50% - 22px)',
        width: 44, height: 44, color: '#b91c1c',
        '&:hover': { bgcolor: '#fef2f2' },
        '&:focus-visible': { outline: '3px solid #352179', outlineOffset: 2 } }}>
      <DeleteOutlineIcon />
    </IconButton>
  </Box>;
}
